import { FC } from "react";

import "./DrawerHeader.scss";
import { ReactComponent as CloseIcon } from "assets/images/iconsV2/x-close.svg";

export type DrawerHeaderProps = {
  /**
   * The title of the drawer.
   */
  title: string;
  /**
   * The supporting text of the drawer.
   */
  supportingText?: string;
  /**
   * A callback function to be executed when the drawer is closed.
   */
  onClose?: () => void;
};

/**
 * TODO: Add icon support when needed
 */
const DrawerHeader: FC<DrawerHeaderProps> = function (props) {
  const { title, supportingText = "", onClose } = props;
  return (
    <div className="drawer-header">
      <div className="d-flex justify-content-between align-items-center">
        <p className="text-xl font-semibold text-primary">{title}</p>
        <CloseIcon className="cursor-pointer" onClick={onClose} />
      </div>
      {supportingText && <p className="text-sm text-tertiary">{supportingText}</p>}
    </div>
  );
};

DrawerHeader.defaultProps = {
  supportingText: "",
  onClose: () => {},
};

export default DrawerHeader;
